import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import Quill from 'quill';
import MagicUrl from 'quill-magic-url';
import { h3Icon, hrIcon } from 'scaleflow/utils/quill-extenstions/custom-icons';
import Hr from 'scaleflow/utils/quill-extenstions/hr';
import ImageFormat from 'scaleflow/utils/quill-extenstions/image-format';
// import registerIfNotRegistered from 'scaleflow/utils/quill-extenstions/registerIfNotRegistered';

Quill.register('formats/image', ImageFormat, true);
Quill.register('modules/magicUrl', MagicUrl, true);
const icons = Quill.import('ui/icons');

icons.header[3] = h3Icon;

icons.hr = hrIcon;

Quill.register({
  'formats/hr': Hr,
});
export default class MoleculesApproachPlanListItemComponent extends Component {
  @service('beta-toggle') betaService;
  @tracked showEditor = false;
  @tracked editorLoading = false;
  @tracked showMore = false;
  notesInterval = null;

  theme = 'bubble';
  timer = null;
  placeholder = 'Add notes';

  editorId;

  get bounds() {
    return `#${this.editorId}`;
  }

  get show() {
    return this.args.show;
  }

  get modules() {
    return {
      toolbar: {
        container: [
          ['bold', 'italic', 'strike'], // toggled buttons
          ['blockquote', 'code-block'],
          [{ header: 1 }, { header: 2 }, { header: 3 }], // custom button values
          [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
          ['link', 'clean', 'image'], // remove formatting button
          // ['hr'],
        ],
      },
      magicUrl: true,
    };
  }

  @action
  onEditorLoadingChange(val) {
    this.editorLoading = val;
  }

  @action
  toggleShowEditor() {
    this.args.week.reload();
    this.showEditor = !this.showEditor;
  }

  @action
  debouncedSave() {
    return this.debounce(() => this.args.week.save(), 1500);
  }

  @action
  debounce(func, timeout = 2000) {
    clearTimeout(this.timer);
    this.timer = setTimeout(func, timeout);
  }

  @action
  setDelta(delta) {
    if (this.args.week.currentState.stateName !== 'root.deleted.inFlight') {
      this.args.week.set('text_delta', delta);
      this.debouncedSave();
    }
  }

  @action
  handleClickOutside() {
    if (!this.showEditor) return;
    this.closeMultiEditor();
    this.startNotesUpdateInterval();
  }

  @action
  closeMultiEditor() {
    if (this.editorLoading) return;
    this.showEditor = false;
  }

  @action
  clearNotesInterval() {
    clearInterval(this.notesInterval);
  }

  @action
  showMultiEditor() {
    if (this.editorLoading) return;
    if (this.showEditor) return;
    this.clearNotesInterval();
    this.args.week.reload().then(() => {
      this.showEditor = true;
      this.showMore = true;
    });
  }

  @action
  toggleShowMore() {
    this.showMore = !this.showMore;
  }

  @action
  startNotesUpdateInterval() {
    this.notesInterval = setInterval(() => {
      this.args.week.reload();
    }, 5000);
  }

  @action
  setEditorId(element) {
    this.editorId = element.id;
  }

  willDestroy() {
    super.willDestroy(...arguments);
    this.clearNotesInterval();
    this.closeMultiEditor();
  }
}
